<script>
import ElForm from 'element-ui/packages/form/src/form'

export default {
  extends: ElForm,
  props: {
    labelPosition: {
      type: String,
      default: 'top'
    },

    hideRequiredAsterisk: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/element/ElForm.vue